import { useId } from 'react'
import { Form } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { Input } from '#app/components/ui/input.tsx'
import { Label } from '#app/components/ui/label.tsx'
import { useLang, useLocalizedPath } from '#app/utils/i18n.ts'
import { cn } from '#app/utils/misc.tsx'

const labels = {
	de: {
		label: 'Suchbegriff',
		placeholder: 'Blog durchsuchen',
		submit: 'Suchen',
	},
	fr: {
		label: 'Terme de recherche',
		placeholder: 'Rechercher dans le blog',
		submit: 'Rechercher',
	},
	en: {
		label: 'Search term',
		placeholder: 'Search the blog',
		submit: 'Search',
	},
} as const

/** GET form that submits `q` to the localized `/blog/search`. */
export function BlogSearchForm({
	defaultQuery = '',
	className,
}: {
	defaultQuery?: string
	className?: string
}) {
	const id = useId()
	const lang = useLang()
	const localePath = useLocalizedPath()

	return (
		<Form
			method="get"
			action={localePath('/blog/search')}
			role="search"
			className={cn('flex items-center gap-2', className)}
		>
			<Label htmlFor={id} className="sr-only">
				{labels[lang].label}
			</Label>
			<Input
				id={id}
				type="search"
				name="q"
				defaultValue={defaultQuery}
				placeholder={labels[lang].placeholder}
			/>
			<Button type="submit">
				<Icon name="magnifying-glass" aria-hidden="true" />
				{labels[lang].submit}
			</Button>
		</Form>
	)
}
